var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72829 21.0459V17.9882C9.72829 17.2077 10.3922 16.5749 11.2113 16.5749H14.2052C14.5985 16.5749 14.9757 16.7238 15.2538 16.9888C15.5319 17.2539 15.6882 17.6134 15.6882 17.9882V21.0459C15.6857 21.3704 15.8192 21.6825 16.0591 21.9128C16.299 22.1431 16.6254 22.2726 16.966 22.2726H19.0085C19.9625 22.2749 20.8783 21.9154 21.5537 21.2734C22.2291 20.6314 22.6087 19.7596 22.6087 18.8504V10.1394C22.6087 9.40504 22.2671 8.70843 21.676 8.23725L14.7275 2.94845C13.5188 2.02114 11.787 2.05109 10.6143 3.01956L3.82437 8.23725C3.20533 8.69454 2.83535 9.39322 2.81706 10.1394V18.8415C2.81706 20.7364 4.42892 22.2726 6.41724 22.2726H8.4132C9.12042 22.2726 9.69518 21.7288 9.70031 21.0548L9.72829 21.0459Z",
    fill: "#9597AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ca085053e2f1a8e1b198ba0d5967905b.svg";
export { ForwardRef as ReactComponent };